import LotSplitDialog from './LotSplitDialog';
import LotSplitDialog_HCC from './LotSplitDialog_HCC';
import LotSplitPackageDialog from './PackageSplit/LotSplitPackageDialog';

const LotSplitDialogSelector = ({ businessUnitCode, ...props }) => {
    switch (businessUnitCode) {
        case "BTBU":
            return <LotSplitPackageDialog {...props} />
        case "HCC_GPPE":
        case "HCC_PP":
        case "HCC_LDPE":
            return <LotSplitDialog_HCC {...props} />
        default:
            return <LotSplitDialog {...props} />
    }
}

export default LotSplitDialogSelector;